import { render, staticRenderFns } from "./UserPreviewModal.vue?vue&type=template&id=f28fadc8&scoped=true&"
import script from "./UserPreviewModal.vue?vue&type=script&lang=js&"
export * from "./UserPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28fadc8",
  null
  
)

export default component.exports